import React from 'react';
import { Card } from '../UI/Card';
import { Zap, Users, BookOpen, Target, HeartHandshake, Lightbulb } from 'lucide-react';
export const SignaturePrograms = () => {
  const programs = [{
    title: 'AI Productivity Bootcamp',
    icon: <Zap className="w-8 h-8 text-white" data-id="element-1042" data-mp="1rya6p29bxw1h" />,
    color: 'bg-blue-600',
    duration: '3-Day Intensive',
    audience: 'Professionals and Teams',
    outcomes: 'AI workflow mastery, 10x productivity, tool integration',
    description: 'A hands-on immersive experience designed to transform how your team works by integrating practical AI tools into their daily workflows.'
  }, {
    title: 'Strategic Networking Masterclass',
    icon: <Users className="w-8 h-8 text-white" data-id="element-1043" data-mp="2at79qaojp77s" />,
    color: 'bg-primary',
    duration: '2-Day Program',
    audience: 'Leaders and Entrepreneurs',
    outcomes: 'Network strategy, relationship capital, visibility',
    description: 'Learn the art and science of building high-trust ecosystems and leveraging relationships for organizational and personal growth.'
  }, {
    title: 'AI for Educators Bootcamp',
    icon: <BookOpen className="w-8 h-8 text-white" data-id="element-1044" data-mp="3l14jlmqxhckb" />,
    color: 'bg-gold-dark',
    duration: '3-Day Program',
    audience: 'Teachers and School Administrators',
    outcomes: 'AI-integrated teaching, curriculum innovation',
    description: 'Equip your teaching staff with the skills to use AI for lesson planning, grading, student engagement, and administrative efficiency.'
  }, {
    title: 'The Modern Marketing Team',
    icon: <Target className="w-8 h-8 text-white" data-id="element-1045" data-mp="7lf63smbh9x7" />,
    color: 'bg-purple-600',
    duration: '2-Day Workshop',
    audience: 'Marketing Teams',
    outcomes: 'Digital marketing mastery, content systems',
    description: 'Retool your marketing department with modern strategies, AI content workflows, and data-driven storytelling techniques.'
  }, {
    title: 'Community Building Masterclass',
    icon: <HeartHandshake className="w-8 h-8 text-white" data-id="element-1046" data-mp="2idhrme4z51me" />,
    color: 'bg-emerald-600',
    duration: '2-Day Program',
    audience: 'Community Managers',
    outcomes: 'Engagement systems, community strategy',
    description: 'Master the frameworks for building, engaging, and sustaining vibrant online and offline communities for your brand or NGO.'
  }, {
    title: 'Program Design Lab',
    icon: <Lightbulb className="w-8 h-8 text-white" data-id="element-1047" data-mp="3qnqn5wad4r4h" />,
    color: 'bg-orange-600',
    duration: '3-Day Intensive',
    audience: 'Program Managers',
    outcomes: 'Impact-driven programs, evaluation frameworks',
    description: 'A collaborative lab where your team will design, structure, and create impact measurement frameworks for new initiatives.'
  }];
  return <section className="py-20 bg-gray-50 border-y border-gray-200" data-id="element-1048" data-mp="iajap73prd0w">
      <div className="container mx-auto px-4" data-id="element-1049" data-mp="daold7zl6vhy">
        <div className="text-center mb-16 scroll-animate" data-id="element-1050" data-mp="r94uf5kx8y39">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1051" data-mp="r9o8gb7gb2c0">
            Signature Training Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1052" data-mp="15vtzdmxy03h1">
            Our flagship learning experiences designed for maximum impact and
            immediate application.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1053" data-mp="wvfc4i1f4eaw">
          {programs.map((program, index) => <Card key={index} className="scroll-animate overflow-hidden p-0 border-0 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" style={{
          transitionDelay: `${index % 3 * 100}ms`
        }} data-id="element-1054" data-mp="10vzbztddlw0q" data-mpi={index}>
              <div className={`${program.color} p-6 flex justify-between items-start`} data-id="element-1055" data-mp="ry5h8mv9fafo">
                <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-1056" data-mp="d8zit148xo8u">
                  {program.icon}
                </div>
                <span className="bg-white/20 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-1057" data-mp="47szyle4k1cf">
                  {program.duration}
                </span>
              </div>
              <div className="p-6 flex-grow flex flex-col bg-white" data-id="element-1058" data-mp="143o6te4ooat">
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1059" data-mp="3sc7q1o72lf28">
                  {program.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow" data-id="element-1060" data-mp="3niwuwkbmemq5">
                  {program.description}
                </p>

                <div className="space-y-3 pt-4 border-t border-gray-100 mt-auto" data-id="element-1061" data-mp="3jgs1nmp33s41">
                  <div data-id="element-1062" data-mp="3el2zdblojx41">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1" data-id="element-1063" data-mp="3ehf6meo27eqd">
                      Who it's for
                    </span>
                    <span className="text-sm font-medium text-navy" data-id="element-1064" data-mp="34m3xcbvf6zq0">
                      {program.audience}
                    </span>
                  </div>
                  <div data-id="element-1065" data-mp="12uqtlq56uxvj">
                    <span className="text-xs font-bold text-gray-400 uppercase tracking-wider block mb-1" data-id="element-1066" data-mp="12sxpoilymrr8">
                      Expected Outcomes
                    </span>
                    <span className="text-sm font-medium text-primary" data-id="element-1067" data-mp="2gqs5vyg24nex">
                      {program.outcomes}
                    </span>
                  </div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};